import NotificationProvider from './NotificationProvider';
import { NotificationContext } from './context';

export { NotificationProvider, NotificationContext };
export default NotificationContext;
